// extracted by mini-css-extract-plugin
export default {"box":"style_box__RAMkG","mine":"style_mine__VdnI7","message":"style_message__djjds","footer":"style_footer__TgQk1","icons":"style_icons__a-7mt"};